const getRandomItem = arr => {
  if (!arr) return
  return arr[Math.floor(Math.random() * arr.length)]
}

export {getRandomItem}
